import React from 'react';
import { connect } from 'react-redux';
import styles from './Vitals.module.css';
import { DBIntField, DBTextArea } from '_components';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';


class PatientCareCenterNoteSubjectiveVitals extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteNavAnchor id='subj_vitals'>
                <div id='subj_vitals'>
                    <div className={styles.row}>
                        <label className={(this.props.isPeds && this.props.isPedsEnabled) ? styles.col1 : styles.col1_req}>Height:</label>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBVITHEIGHTFT'
                            min={0}
                            max={10}
                            className={styles.col2}
                        />
                        <label className={styles.col3}>ft.</label>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBVITHEIGHTIN'
                            min={0}
                            max={12}
                            className={styles.col4}
                        />
                        <label className={styles.col5}>in.</label>
                    </div>
                    <div className={styles.row}>
                        <label className={(this.props.isPeds && this.props.isPedsEnabled) ? styles.col1 : styles.col1_req}>Weight:</label>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBVITWEIGHT'
                            min={0}
                            max={1000}
                            className={styles.col2}
                        />
                        <label className={styles.col3}>lbs.</label>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.col1}>Blood Pressure:</label>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBVITBPSYS'
                            min={0}
                            max={250}
                            className={styles.col2}
                        />
                        <label className={styles.col3}>/</label>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBVITBPDIAS'
                            min={0}
                            max={250}
                            className={styles.col4}
                        />
                        <label className={styles.col5}>mmHg</label>
                    </div>
                    <div className={styles.row}>
                        <div className={styles.col1_top}>Other:</div>
                        <DBTextArea
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBVITOTHER'
                            className={styles.textarea}
                        />
                    </div>
                </div>
            </PatientCareCenterNoteNavAnchor>
        );
    }

}

function mapStateToProps(state) {
    //eval only note
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let epno = state.entities.notes.PTEVAL[evno].EVEPNO;


    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;


    return {
        noteId: noteId,
        evno: evno,
        isPeds,
        isPedsEnabled
    };
}

const connectedPatientCareCenterNoteSubjectiveVitals = connect(mapStateToProps)(PatientCareCenterNoteSubjectiveVitals);
export { connectedPatientCareCenterNoteSubjectiveVitals as PatientCareCenterNoteSubjectiveVitals };

